import { formatBRL } from "../lib/format";
import { useCart } from "../context/CartContext";

const Row = ({ label, value, strong, accent }) => (
  <div className="flex items-center justify-between text-sm">
    <span className={strong ? "font-semibold text-slate-900" : "text-slate-600"}>{label}</span>
    <span className={`${strong ? "text-lg font-extrabold text-slate-900" : accent ? "text-emerald-600 font-medium" : "text-slate-800 font-medium"}`}>
      {value}
    </span>
  </div>
);

const OrderSummary = ({ showItems = false, footer }) => {
  const { items, subtotal, shipping, discount, total } = useCart();

  return (
    <div className="bg-white border border-slate-200 rounded-lg p-5" data-testid="order-summary">
      <h2 className="text-lg font-semibold text-slate-900 mb-4">Resumo do pedido</h2>

      {showItems && items.length > 0 && (
        <div className="space-y-3 mb-4 pb-4 border-b border-slate-200 max-h-64 overflow-y-auto">
          {items.map((i) => (
            <div key={i.product.id} className="flex items-center gap-3">
              <img src={i.product.image} alt="" className="h-12 w-12 rounded-md object-cover bg-slate-50 border border-slate-200" />
              <div className="flex-1 min-w-0">
                <p className="text-sm text-slate-800 line-clamp-1">{i.product.name}</p>
                <p className="text-xs text-slate-500">Qtd: {i.qty}</p>
              </div>
              <span className="text-sm font-medium text-slate-800">{formatBRL(i.product.price * i.qty)}</span>
            </div>
          ))}
        </div>
      )}

      <div className="space-y-3">
        <Row label="Subtotal" value={formatBRL(subtotal)} />
        <Row label="Entrega" value={shipping === 0 ? "Grátis" : formatBRL(shipping)} accent={shipping === 0} />
        <Row label="Desconto" value={discount > 0 ? `- ${formatBRL(discount)}` : formatBRL(0)} accent={discount > 0} />
        <div className="border-t border-slate-200 pt-3">
          <Row label="Total" value={formatBRL(total)} strong />
        </div>
      </div>

      {footer}
    </div>
  );
};

export default OrderSummary;
